// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__E2itp","divider":"styles_divider__ThKg7"};